import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTriangleLeftMedium"><Path d="M12.5351 7.21077C13.5109 6.39103 14.9998 7.08476 14.9999 8.3592V15.6405C14.9997 16.9147 13.5109 17.6084 12.5351 16.7889L8.20109 13.1483C7.48764 12.5489 7.48768 11.4508 8.20109 10.8514L12.5351 7.21077Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
